// extracted by mini-css-extract-plugin
export var icon = "_b2-3";
export var subtitle = "_b2-2";
export var title = "_b2-1";
export var value = "_b2-0";